import PageCorpo from '../../Components/Page-Corpo/corpo';
import Agendamento from '../../Components/Banner-Agendamentos/BanAgendamentos';
import Footer from '../../Components/Footer/Footer';

function Corpo() {
  return (
    <>
      <div id="Corpo">
        <PageCorpo />
      </div>
      <div id="Agendamento">
        <Agendamento/>
      </div>
      <div id="Footer">
        <Footer />
      </div>
    </>
  );
}

export default Corpo;